import React, {useEffect, useState} from 'react';
import Input from '../../Input';
import SimpleModal from '../../SimpleModal';
import Select from 'react-select';
import {timeOptions} from '../../../pages/BuildInspection/buildInspectionUtils';
import './index.scss';
import {useDispatch} from 'react-redux';
import {useCreateEquipmentMutation} from '../../../store/builder/inspections.api';
import {toast} from 'react-toastify';
import {useErrorHandler} from '../../../global/ErrorsHandler';
import useLoader from '../../../global/UseLoadingHandler';
import {useTranslation} from '../../../hooks/useTranslation';

const CreateEquipmentModal = ({
  exit,
  equipmentTypeData,
  facilityData,
  getEquipmentByTypes,
  getEquipmentsActions,
  equipmentTypeCategory,
}) => {
  const dispatch = useDispatch();
  const {t} = useTranslation();

  const [state, setState] = useState({
    title: null,
    equipment_type_id: equipmentTypeCategory.value,
    facility_id: null,
  });

  const [
    createEquipment,
    {
      isLoading: createEquipmentIsLoading,
      error: createEquipmentError,
      isSuccess: createEquipmentIsSuccess,
    },
  ] = useCreateEquipmentMutation();

  useLoader([createEquipmentIsLoading]);

  const [errorHandler, setErrorHandler] = useErrorHandler([
    createEquipmentError,
  ]);

  const submitCreate = () => {
    if (!state.title || !state.equipment_type_id || !state.facility_id) {
      toast.error(t('createEquipmentModal.fillAllFields'));
      return;
    } else {
      createEquipment(state)
        .unwrap()
        .then(res => {
          toast.success(t('createEquipmentModal.equipmentCreatedSuccessfully'));
          getEquipmentByTypes();
          getEquipmentsActions();
          exit();
        })
        .catch(err => {});
    }
  };

  return (
    <SimpleModal
      title={t('createEquipmentModal.title')}
      exit={() => exit()}
      submitAction={() => submitCreate()}
      submitTitle={t('createEquipmentModal.buttons.create')}
    >
      <div className='equipmentForm'>
        <Input
          customStyles={{margin: '0', width: '100%'}}
          titleStyles={{fontSize: '16px', color: 'black'}}
          id='id'
          name='id'
          placeholder={t('createEquipmentModal.enterIdPlaceholder')}
          label={t('createEquipmentModal.enterIdLabe')}
          type='text'
          onChange={e => setState(old => ({...old, title: e.target.value}))}
        />
        {/*<div className="equipmentForm-item">*/}
        {/*  <span className="createForm-item__label">{t('createEquipmentModal.equipmentTypeLabel')}</span>*/}
        {/*  <Select*/}
        {/*    options={equipmentTypeData?.map(el => ({label: el.title, value: el.id}))}*/}
        {/*    placeholder={t('createEquipmentModal.selectEquipmentTypePlaceholder')}*/}
        {/*    styles={{*/}
        {/*      control: (baseStyles, state) => ({*/}
        {/*        ...baseStyles,*/}
        {/*        borderColor: state.isFocused ? "#E9EAEB" : "#E9EAEB",*/}
        {/*        borderRadius: 8,*/}
        {/*        width: '100%',*/}
        {/*        height: 43,*/}
        {/*        fontSize: 14,*/}
        {/*        backgroundColor: "#F4F5F6",*/}
        {/*        color: "#718096",*/}
        {/*      }),*/}
        {/*    }}*/}
        {/*    onChange={(e) => setState(old => ({...old, equipment_type_id: e.value}))}*/}
        {/*  />*/}
        {/*</div>*/}
        <div className='equipmentForm-item'>
          <span className='createForm-item__label'>{t('createEquipmentModal.facilityLabel')}</span>
          <Select
            options={facilityData?.map(el => ({
              label: el.name,
              value: el.id,
            }))}
            placeholder={t('createEquipmentModal.selectFacilityPlaceholder')}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                borderColor: state.isFocused ? '#E9EAEB' : '#E9EAEB',
                borderRadius: 8,
                width: '100%',
                height: 43,
                fontSize: 14,
                backgroundColor: '#F4F5F6',
                color: '#718096',
              }),
            }}
            onChange={e => setState(old => ({...old, facility_id: e.value}))}
          />
        </div>
        {/*<div className="equipmentForm-item">*/}
        {/*  <span className="createForm-item__label">{t('createEquipmentModal.fuelTypeLabel')}</span>*/}
        {/*  <Select*/}
        {/*    options={options}*/}
        {/*    placeholder={t('createEquipmentModal.selectFuelTypePlaceholder')}*/}
        {/*    styles={{*/}
        {/*      control: (baseStyles, state) => ({*/}
        {/*        ...baseStyles,*/}
        {/*        borderColor: state.isFocused ? "#E9EAEB" : "#E9EAEB",*/}
        {/*        borderRadius: 8,*/}
        {/*        width: '100%',*/}
        {/*        height: 43,*/}
        {/*        fontSize: 14,*/}
        {/*        backgroundColor: "#F4F5F6",*/}
        {/*        color: "#718096",*/}
        {/*      }),*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</div>*/}
      </div>
    </SimpleModal>
  );
};

export default CreateEquipmentModal;
